import { styled } from 'styled-components';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;

  > * {
    min-width: 0;
    height: 100%;
  }

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const EditColumns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: stretch;

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const EditMain = styled.div`
  min-width: 0;
  padding-right: 16px;

  @media (max-width: 991px) {
    padding-right: 0;
  }
`;

export const EditAside = styled.div`
  min-width: 0;
  padding-left: 16px;
  border-left: 1px solid #e6e8ee;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 991px) {
    padding-left: 0;
    padding-top: 16px;
    margin-top: 16px;
    border-left: none;
    border-top: 1px solid #e6e8ee;
  }
`;

export const Card = styled.section`
  border: 1px solid #e6e8ee;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
`;

export const CardTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: #1f2430;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 16px;

  > .ant-form-item {
    min-width: 0;
    max-width: 100%;
    margin-bottom: 12px;
  }

  .ant-form-item-label,
  .ant-form-item-control,
  .ant-select,
  .ant-input,
  .ant-input-textarea {
    min-width: 0;
    max-width: 100%;
  }

  .ant-form-item-label > label,
  .ant-select-selection-item,
  .ant-select-selection-placeholder,
  input.ant-input {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .full-width-field {
    grid-column: 1 / -1;
  }

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FieldPair = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 16px;

  > .ant-form-item {
    min-width: 0;
    max-width: 100%;
    margin-bottom: 12px;
  }

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Hint = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f3f7ff;
  color: #3d4d66;
  font-size: 12px;
  line-height: 1.4;
`;

export const GradeCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: #f7f9fc;
`;

export const GradeTitle = styled(CardTitle)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
`;

export const GradeMetric = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: #fff;
`;

export const GradeLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #1f2430;
`;

export const GradeValues = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
  align-items: center;
`;

export const GradeArrow = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: 28px;
  line-height: 1;
`;

export const GradeBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-self: center;
  width: min(100px, 100%);
  max-width: 100%;
  border: none;
`;

export const MiniLabel = styled.div`
  margin-bottom: 2px;
  font-size: 11px;
  text-align: center;
`;

export const MiniValue = styled.div<{
  $tone?: 'neutral' | 'improved' | 'worsened';
}>`
  box-sizing: border-box;
  width: 100%;
  padding: 4px 6px;
  border: none;
  border-radius: 6px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 991px) {
    font-size: clamp(16px, 4vw, 22px);
  }
  background: ${({ $tone }) =>
    $tone === 'improved'
      ? '#e8f8ee'
      : $tone === 'worsened'
        ? '#fdecec'
        : '#e4e7ee'};
  color: ${({ $tone }) =>
    $tone === 'improved'
      ? '#12b76a'
      : $tone === 'worsened'
        ? '#d92d20'
        : '#1f2430'};
`;

export const GradeSummary = styled.div<{
  $tone: 'neutral' | 'improved' | 'worsened';
}>`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 6px 8px;
  border-radius: 8px;
  background: ${({ $tone }) =>
    $tone === 'improved'
      ? '#e8f8ee'
      : $tone === 'worsened'
        ? '#fdecec'
        : '#d5d9e2'};
  color: #344054;
  font-size: 12px;
  line-height: 1.45;

  strong {
    color: ${({ $tone }) =>
      $tone === 'improved'
        ? '#12b76a'
        : $tone === 'worsened'
          ? '#d92d20'
          : '#344054'};
  }
`;

export const ReadOnlyItem = styled.div`
  min-width: 0;
`;

export const ReadOnlyLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #667085;
  margin-bottom: 4px;
`;

export const ReadOnlyValue = styled.div`
  min-height: 36px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f4f5f7;
  color: #344054;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
`;

export const CodeTag = styled.span`
  display: inline-block;
  max-width: 100%;
  padding: 2px 8px;
  border: 1px solid #e6e8ee;
  border-radius: 6px;
  background: #f4f5f7;
  color: #344054;
  font-size: 12px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EditTitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const EditTitleHint = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: #667085;
`;

export const StagingModeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 2px 12px;
  border-radius: 999px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #c2410c;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
`;

export const StagingModeDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f59e0b;
  flex: 0 0 auto;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;

  @media (max-width: 991px) {
    .footer-cancel {
      display: none;
    }
  }
`;
